import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-background"
    >
      <div className="mx-auto max-w-7xl px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 text-sm text-secondary max-w-sm leading-relaxed">
              A hospital diet assessor platform by Mesron Healthcare LLP —
              built to digitise clinical dietary workflows for Indian
              hospitals.
            </p>
            <div className="mt-6 font-mono text-[11px] uppercase tracking-widest text-secondary space-y-1">
              <p>Mesron Healthcare LLP</p>
              <p>LLPIN · ACD-8580</p>
              <p>Incorporated · 19 Nov 2023</p>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-4">
              Product
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-foreground text-secondary" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-foreground text-secondary" data-testid="footer-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-foreground text-secondary" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-4">
              Legal
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-foreground text-secondary" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-foreground text-secondary" data-testid="footer-terms">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <a
                  href="mailto:admin@dietico.co.in"
                  className="hover:text-foreground text-secondary"
                  data-testid="footer-email"
                >
                  admin@dietico.co.in
                </a>
              </li>
              <li>
                <a
                  href="tel:+919002296906"
                  className="hover:text-foreground text-secondary"
                  data-testid="footer-phone"
                >
                  +91 9002296906
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Full logo lockup (icon + wordmark) */}
        <div className="mt-20 -mb-4 flex justify-center">
          <div className="w-full max-w-4xl rounded-3xl bg-white p-8 md:p-12 border border-border">
            <img
              src="/dietico-logo-full.png"
              alt="Dietico — Hospital Diet Assessor by Mesron Healthcare LLP"
              width="1024"
              height="512"
              loading="lazy"
              decoding="async"
              className="w-full h-auto select-none"
            />
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-secondary">
          <p>© 2023–2026 Mesron Healthcare LLP. All rights reserved.</p>
          <p className="font-mono uppercase tracking-widest text-[10px]">
            Registered Office · 159/63 Hindusthan Park, Hirapur, Asansol
            713304, West Bengal, India
          </p>
        </div>
      </div>
    </footer>
  );
}
